import {
  TenantsSearchAllFilters,
  TenantsSearchSideFilters,
} from '@kamernet/modules/Search/types';

export function mapTenantsSearchAllFiltersToSideFilters(
  allFilters: TenantsSearchAllFilters,
): TenantsSearchSideFilters {
  const sideFilters: TenantsSearchSideFilters = {
    furnishings: allFilters.furnishings,
    availabilityPeriods: allFilters.availabilityPeriods,
    suitableForNumberOfPersons: allFilters.suitableForNumberOfPersons,
    suitableForGenders: allFilters.suitableForGenders,
    suitableForAgeRange: allFilters.suitableForAgeRange,
    suitableForWorkStatuses: allFilters.suitableForWorkStatuses,
    isSmokingInsideAllowed: allFilters.isSmokingInsideAllowed,
    isPetsInsideAllowed: allFilters.isPetsInsideAllowed,
    roommateNumberMax: allFilters.roommateNumberMax,
    roommateGenders: allFilters.roommateGenders,
    maxRent: allFilters.maxRent,
    minSize: allFilters.minSize,
  };

  return sideFilters;
}
